<template>
  <v-container>
    <div class="hidden-sm-and-down">
      <v-card>
        <v-row no-gutters>
          <v-col
            cols="3"
            class="d-flex pa-0 ma-0"
            style="max-width: 17% !important;"
          >
            <v-card-title class="pb-0">Avalie seu pedido</v-card-title>
          </v-col>
          <v-col cols="9" class="d-flex pa-0 ma-0">
            <div
              v-if="
                pedido.bpdStrStatus !== 'ORÇAMENTO PENDENTE' &&
                  pedido.bpdStrStatus !== 'AGP'
              "
            >
              <v-rating
                v-model="pedido.bpdIntAvaliacao"
                @input="alterarAvaliacao(pedido)"
                :readonly="pedido.bpdIntAvaliacao > 0"
                class="pt-4"
              ></v-rating>
            </div>
          </v-col>
        </v-row>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="itens"
            :single-expand="singleExpand"
            :expanded.sync="expanded"
            item-key="bpiIntCod"
            show-expand
            :disable-pagination="true"
          >
            <template v-slot:item.action="{ item }">
              <v-btn
                icon
                color="grey"
                v-if="
                  item.bpiStrStatus !== 'SCN' && item.bpiStrStatus !== 'CAN'
                "
                @click="estorno(item.bpiIntCod)"
                v-model="item.estorno"
                class="pa-0"
              >
                <v-icon>undo</v-icon>
              </v-btn>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-timeline align-top right>
                  <v-timeline-item
                    fill-dot
                    right
                    v-for="i in item.logs"
                    :key="i.pilIntCod"
                    :color="calculaCor(i.pilStrStatus)"
                    :icon="calculaIcones(i.pilStrStatus)"
                  >
                    <v-card class="elevation-1" style="width:150px;">
                      <v-card-title class="subtitle-2 font-weight-black pb-0">{{
                        i.pilStrStatusDescricao
                      }}</v-card-title>
                      <v-card-text class="pt-0">
                        {{ i.pilDtmCriacao | formatDateTime }}
                      </v-card-text>
                      <v-card-title
                        class="subtitle-2 font-weight-black pt-0 pb-0"
                        v-if="i.pilStrStatus.toLowerCase() === 'enviado'"
                        >CÓD. RASTREIO</v-card-title
                      >
                      <v-card-text
                        class="pt-0"
                        v-if="i.pilStrStatus.toLowerCase() === 'enviado'"
                        >{{ item.bpiStrRastreio }}</v-card-text
                      >

                      <!-- <template v-slot:item.estorno="{ item }" > -->
                      <!-- <div class="d-flex">
                        <v-card-text
                          class="pl-2 pa-0 d-flex justify-center align-center"
                          v-if="i.pilStrStatus.toLowerCase() === 'recebido'"
                        >Solicitar estorno</v-card-text>
                        <v-btn
                          icon
                          color="grey"
                          @click="estorno(item.bpiIntCod)"
                          v-model="item.estorno"
                          v-if="i.pilStrStatus.toLowerCase() === 'recebido'"
                          class="pa-0"
                        >
                          <v-icon>undo</v-icon>
                        </v-btn>
                      </div>-->
                      <!-- </template> -->
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </td>
            </template>
            <!-- <template v-slot:item.action="{ item }">
              <div v-if="orcamento && item.bpiStrStatus === 'ORÇAMENTO REALIZADO'">
                <v-icon
                  small
                  class="mr-2"
                  @click="acaoOrcamento(item, true)"
                  title="Aprovar Orçamento"
                >far fa-thumbs-up</v-icon>
                <v-icon
                  small
                  @click="acaoOrcamento(item, false)"
                  title="Reprovar Orçamento"
                >far fa-thumbs-down</v-icon>
              </div>

              <a :href="item.bpdStrNotaPDFURL" v-if="item.bpdStrNotaPDFURL">
                <v-icon small class="mr-2" title="Baixar Nota Fiscal">far fa-file-pdf</v-icon>
              </a>
            </template>-->
          </v-data-table>
        </v-card-text>

        <v-card-actions class="justify-center pt-6 pb-8">
          <v-btn
            small
            depressed
            outlined
            absolute
            color="var(--vs-azul-primaria)"
            v-if="pedido.bpdStrStatus === 'ENV'"
            @click="confirmarRecebimento()"
            >CONFIRMAR RECEBIMENTO</v-btn
          >
          <div v-if="pedido.bpdStrStatus === 'ENT'">
            Recebido em
            {{ pedido.bpdDtmRecebido | formatDateTime }}
          </div>
        </v-card-actions>
      </v-card>
    </div>

    <div class="hidden-md-and-up">
      <v-card class="mx-2 mb-4" v-for="(item, i) in itens" :key="i">
        <v-card-title class="pb-0">Avalie seu pedido</v-card-title>
        <div
          v-if="
            pedido.bpdStrStatus !== 'ORÇAMENTO PENDENTE' &&
              pedido.bpdStrStatus !== 'AGP'
          "
        >
          <v-rating
            v-model="pedido.bpdIntAvaliacao"
            @input="alterarAvaliacao(pedido)"
            :readonly="pedido.bpdIntAvaliacao > 0"
            class="pl-1"
          ></v-rating>
        </div>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="7" class="d-flex">
              <span class="pa-0">Pedido número</span>
              <span class="pa-0 pl-2 font-weight-black">{{
                item.idPedido
              }}</span>
            </v-col>
            <v-col cols="5" class="d-flex justify-end">
              <span class="pa-0 pl-2 font-weight-black">{{
                item.dataPedido
              }}</span>
            </v-col>
            <v-col cols="12" class="pb-3 pt-2">
              <span class="pa-0 font-weight-black subtitle-1">{{
                item.item
              }}</span>
            </v-col>
            <v-col cols="5">
              <span class="pa-0">Quantidade</span>
              <span class="pa-0 pl-2 font-weight-black">{{
                item.bpiIntQtd
              }}</span>
            </v-col>
            <v-col cols="7" class="d-flex justify-end">
              <span class="pa-0">Status</span>
              <span class="pa-0 pl-2 font-weight-black">{{
                item.bpiStrStatus
              }}</span>
            </v-col>
            <v-col cols="7" class="pt-3">
              <span class="pa-0">Preço unitário</span>
            </v-col>
            <v-col cols="5" class="d-flex justify-end pt-3">
              <span class="pa-0 pl-2 font-weight-black">{{
                item.bpiFltPrecoVendaStr
              }}</span>
            </v-col>
            <v-col cols="7">
              <span class="pa-0">Preço total</span>
            </v-col>
            <v-col cols="5" class="d-flex justify-end">
              <span class="pa-0 pl-2 font-weight-black black--text">{{
                item.bpiFltPrecoTotalStr
              }}</span>
            </v-col>
          </v-row>

          <v-expansion-panels class="pt-4" focusable>
            <v-expansion-panel>
              <v-expansion-panel-header color="grey lighten-2"
                >Andamento do pedido</v-expansion-panel-header
              >
              <v-expansion-panel-content>
                <v-timeline align-top left dense>
                  <v-timeline-item
                    fill-dot
                    small
                    v-for="i in item.logs"
                    :key="i.pilIntCod"
                    :color="calculaCor(i.pilStrStatus)"
                    :icon="calculaIcones(i.pilStrStatus)"
                  >
                    <v-card class="elevation-1" style="width:250px;">
                      <v-card-title class="subtitle-2 font-weight-black pb-0">{{
                        i.pilStrStatus
                      }}</v-card-title>
                      <v-card-text class="pt-0">
                        {{ i.pilDtmCriacao | formatDateTime }}
                      </v-card-text>
                      <v-card-title
                        class="caption font-weight-black pt-0 pb-0"
                        v-if="i.pilStrStatus.toLowerCase() === 'enviado'"
                        >Cód. rastreio</v-card-title
                      >
                      <v-card-text
                        class="pt-0"
                        v-if="i.pilStrStatus.toLowerCase() === 'enviado'"
                        >{{ item.bpiStrRastreio }}</v-card-text
                      >
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-btn
            color="var(--vs-cinza)"
            @click="estorno(item.bpiIntCod)"
            v-model="item.estorno"
            class="mt-4 ma-0 float-right"
            text
          >
            <v-icon class="pr-4">undo</v-icon>Solicitar cancelamento
          </v-btn>
          <!-- <template v-slot:item.action="{ item }">
            <div v-if="orcamento && item.bpiStrStatus === 'ORÇAMENTO REALIZADO'">
              <v-icon
                small
                class="mr-2"
                @click="acaoOrcamento(item, true)"
                title="Aprovar Orçamento"
              >las la-thumbs-up</v-icon>
              <v-icon
                small
                @click="acaoOrcamento(item, false)"
                title="Reprovar Orçamento"
              >las la-thumbs-down</v-icon>
            </div>

            <a :href="item.bpdStrNotaPDFURL" v-if="item.bpdStrNotaPDFURL">
              <v-icon small class="mr-2" title="Baixar Nota Fiscal">las la-file-pdf</v-icon>
            </a>
          </template>-->
        </v-card-text>

        <v-card-actions class="justify-center pt-6 pb-8">
          <v-btn
            small
            depressed
            outlined
            absolute
            color="var(--vs-azul-primaria)"
            v-if="pedido.bpdStrStatus === 'ENV'"
            @click="confirmarRecebimento()"
            >CONFIRMAR RECEBIMENTO</v-btn
          >
          <div v-if="pedido.bpdStrStatus === 'ENT'">
            Recebido em
            {{ pedido.bpdDtmRecebido | formatDateTime }}
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import Alert from "../utils/alert/index";

export default {
  data: () => ({
    expanded: [],
    singleExpand: true,
    headers: [
      { text: "Número", value: "idPedido" },
      { text: "Data", value: "dataPedido" },
      { text: "Item", value: "item" },
      { text: "Qtd.", value: "bpiIntQtd" },
      { text: "Preço Unit.", value: "bpiFltPrecoVendaStr" },
      { text: "Preço Total", value: "bpiFltPrecoTotalStr" },
      { text: "Status", value: "bpiStrStatusDescricao" },
      { text: "Ação", value: "action", sortable: false },
      { text: "", value: "data-table-expand" },
    ],
  }),
  mounted() {},
  methods: {
    estorno(item) {
      self = this;
      Alert.confirm(
        "Solicitar cancelamento!",
        "Você tem certeza que gostaria de solicitar o cancelamento deste item?"
      ).then(function(isConfirm) {
        if (isConfirm.value === true) {
          // console.log(item)
          self.$store.dispatch("pedido/solicitarEstorno", item);
        }
      });
    },
    confirmarRecebimento() {
      this.$store.dispatch("pedido/confirmarRecebimento", this.pedido);
    },
    alterarAvaliacao(item) {
      this.$store.dispatch("pedido/salvarAvaliacao", item);
    },
    acaoOrcamento(item, acao) {
      if (acao) {
        item.bpiStrStatus = "ORÇAMENTO APROVADO";
      } else {
        item.bpiStrStatus = "ORÇAMENTO REPROVADO";
      }
      this.$store.dispatch("pedido/salvarItem", item);
    },
    calculaCor(s) {
      if (s.toUpperCase() === "AGP") {
        return "yellow darken-2";
      } else if (s.toUpperCase() === "PGA" || s.toUpperCase() === "PGM") {
        return "blue darken-1";
      } else if (s.toUpperCase() === "ENV") {
        return "green darken-1";
      } else if (s.toUpperCase() === "CAN") {
        return "red darken-1";
      } else if (s.toUpperCase() === "REC") {
        return "red darken-3";
      } else if (s.toUpperCase() === "ENT") {
        return "green darken-4";
      } else if (s.toUpperCase() === "orçamento pendente") {
        return "blue-grey darken-2";
      } else if (s.toUpperCase() === "orçamento realizado") {
        return "blue darken-3";
      } else if (s.toUpperCase() === "orçamento aprovado") {
        return "green darken-3";
      } else if (s.toUpperCase() === "orçamento reprovado") {
        return "red darken-3";
      }
    },
    calculaIcones(s) {
      if (s.toUpperCase() === "AGP") {
        return "las la-stopwatch";
      } else if (s.toUpperCase() === "PGA" || s.toUpperCase() === "PGM") {
        return "las la-dollar-sign";
      } else if (s.toUpperCase() === "ENV") {
        return "las la-truck";
      } else if (s.toUpperCase() === "CAN") {
        return "las la-ban";
      } else if (s.toUpperCase() === "REC") {
        return "las la-hand-paper";
      } else if (s.toUpperCase() === "ENT") {
        return "las la-check-circle";
      } else if (s.toLowerCase() === "orçamento pendente") {
        return "mdi-account-question-outline";
      } else if (s.toLowerCase() === "orçamento realizado") {
        return "mdi-account-arrow-right-outline";
      } else if (s.toLowerCase() === "orçamento aprovado") {
        return "mdi-account-check-outline";
      } else if (s.toLowerCase() === "orçamento reprovado") {
        return "mdi-account-alert-outline";
      }
    },
  },
  computed: {
    ...mapGetters({
      itens: "pedido/itens",
      pedido: "pedido/pedido",
      user: "cliente/user",
      orcamento: "cliente/orcamento",
    }),
  },
};
</script>

<style scoped>
.v-data-footer,
.v-data-table-header-mobile__wrapper {
  display: none;
}

.v-data-table tbody tr.expanded.expanded__content {
  box-shadow: none;
  background: #fafafa !important;
  margin-bottom: 4px !important;
}

.theme--light.v-data-table tbody tr:hover:not(.v-data-table__expand-row) {
  background: #eae3db;
}

.theme--light.v-data-table tbody tr.expanded.expanded__row {
  background: #eae3db;
}
tbody {
  cursor: pointer;
}

.v-expansion-panel-content__wrap {
  padding-left: 0px !important;
  padding-right: 10px !important;
}

th {
  vertical-align: top !important;
}
</style>
